<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" label-width="80px">
        <el-form-item label="预估节点">
          <el-input v-model.trim="form.nodeName"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="search">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="add">新增</el-button>
        <el-tooltip class="item" effect="dark" content="每月默认预估节点有预估、预估调整，不用进行配置" placement="top-start">
          <span class="el-icon-warning-outline"></span>
        </el-tooltip>
      </template>
      <el-table
        :data="tableData"
        :height="maxTableHeight"
        ref="table"
        v-loading="loading"
        border
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column label="预估节点" prop="nodeName"></el-table-column>
        <el-table-column label="年份" prop="year"></el-table-column>
        <el-table-column label="月份" prop="month"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scoped">
            <span v-if="scoped.row.status">已提报</span>
            <span v-if="!scoped.row.status">未提报</span>
          </template>
        </el-table-column>
        <el-table-column label="更新人" prop="updateBy"></el-table-column>
        <el-table-column label="更新时间" prop="updateTime"></el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scoped" v-if="!scoped.row.status">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
            background
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- dialog -->
    <v-dialog v-model="dialogVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
      <div slot="content">
        <add-edit ref="content" :data="rowData" v-if="dialogVisible"></add-edit>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js';
import tableMixin from '@/utils/tableMixin';
import addEdit from './components/add&edit/add&edit';

export default {
  components: { addEdit },
  mixins: [mixin, tableMixin],
  data() {
    return {
      form: {
        status: ''
      },
      tableData: [],
      loading: false,
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      dialogVisible: false,
      dialogConfig: {},
      rowData: {}
    };
  },
  computed: {
    statusOptions() {
      return [{
        name: '全部',
        value: ''
      }, {
        name: '已提报',
        value: true
      }, {
        name: '未提报',
        value: false
      }];
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 列表初始化
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.form
        }
      };
      let res = await this.$q.preSalePlan.predictionNodeListPage({ data });
      if (res.success && res.data && res.data.records.length) {
        this.tableData = res.data.records;
        this.$set(this.paginationOpt, 'total', res.data.total);
      } else {
        this.tableData = [];
        this.paginationOpt.total = 0;
      }
      this.loading = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // 搜索
    search() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 重置
    reset() {
      this.paginationOpt.pageNum = 1;
      this.paginationOpt.pageSize = this.paginationOpt.pageSizes[0];
      this.form = {
        status: ''
      };
      this.init();
    },
    // 新增 弹出dialog
    add() {
      this.dialogConfig = {
        title: '新增',
        width: '30%',
        confirmCallback: true
      };
      this.rowData = {};
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.dialogConfig = {
        title: '编辑',
        width: '30%',
        confirmCallback: true
      };
      this.rowData = row;
      this.dialogVisible = true;
    },
    // 弹窗 确认事件
    dialogConfirm() {
      this.$refs['content'].$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (JSON.stringify(this.rowData) === '{}') {
            this.insertList();
          } else {
            this.updateList();
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 新增接口
    async insertList() {
      let data = this.$refs['content'].formData;
      let { nodeName, nodeTime } = data;
      let res = await this.$q.preSalePlan.predictionNodeAdd({ data: { nodeName, nodeTime } });
      if (res.success) {
        this.$message.success('新增成功');
      } else {
        this.$message.fail('新增失败');
      }
      this.dialogVisible = false;
      this.init();
    },
    // 修改接口
    async updateList() {
      let data = this.$refs['content'].formData;
      data['id'] = this.rowData['id'];
      let { id, nodeName, nodeTime } = data;
      let res = await this.$q.preSalePlan.predictionNodeModify({ data: { id, nodeName, nodeTime } });
      if (res.success) {
        this.$message.success('修改成功');
      } else {
        this.$message.fail('修改失败');
      }
      this.dialogVisible = false;
      this.init();
    },
    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？",'提示', {type: 'warning'});
      if (status !== 'confirm') return;
      let res = await this.$q.preSalePlan.predictionNodeMove({ fragment: [row.id] });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.init();
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.footerBox
  text-align right

>>> .el-icon-warning-outline
  font-size 16px
  margin-left 10px
  color #777
</style>
